module.exports = __webpack_public_path__ + "static/img/businessUser.286afb03.svg";